import React from "react";
import "../stylesheets/LeftHero.css";
import logoImage from "../images/label-colors.png";
import truckImage from "../images/truck.jpg";

export default function LeftHero() {
  return (
    <>
      {/* Fondo del camión */}
      <div 
        className="truck-background"
        style={{ backgroundImage: `url(${truckImage})` }}
      ></div>
      
      {/* Logo superpuesto */}
      <img src={logoImage} alt="InTrucks logo" className="logo-overlay" />
    </>
  );
}